import React, { useEffect, useRef } from 'react';
import styles from './CustomerInfo.module.scss';
import CustomerBillingInfoForm, { CustomerBillingInfoFormHandle } from 'components/billing/CustomerBillingForm/CustomerBillingInfoForm';
import { useNavigate } from 'react-router-dom';
import Button from 'components/shared/Button';
import { useCustomerInfoContext } from '../contexts/CustomerInfoContext';
import PageTitle from 'components/shared/PageTitle';
import { useSelector } from 'react-redux';
import { updateCustomer } from 'features/billing/customer/customerActions';
import { customerInfoSelector } from 'features/billing/customer/customerSlice';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'app/store';
import { billingFormsCustomerInfoSelector } from 'features/billing/formStates/billingFormsInfo/billingFormsInfoSlice';
import { setCustomerFormInfoTaxIdErrors } from 'features/billing/formStates/billingFormsInfo/billingFormsInfoActions';

const CustomerInfo: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { setCustomerInfoFormRef } = useCustomerInfoContext();
  const customerInfo = useSelector(customerInfoSelector);
  const customerFormInfo = useSelector(billingFormsCustomerInfoSelector);

  const customerInfoFormRef = useRef<CustomerBillingInfoFormHandle>(null);

  useEffect(() => {
    setCustomerInfoFormRef(customerInfoFormRef as React.RefObject<any>);
    return () => setCustomerInfoFormRef(null);
  }, [customerInfoFormRef, setCustomerInfoFormRef]);

  const handleRedirect = async () => {
    const triggerResult = customerInfoFormRef.current?.triggerSubmit();

    const customerUpdateResult = await dispatch(updateCustomer({
      customerId: customerInfo.id,
      address: triggerResult!.address,
      enableAutomaticTax: true,
      taxIds: Object.entries(triggerResult!.taxIds).map(([type, id]) => ({ type, id })),
    }));

    if (customerUpdateResult.meta.requestStatus === 'rejected') {
      toast.error('Please fill in valid value for TAX ID');
      dispatch(setCustomerFormInfoTaxIdErrors(
        Object.keys(customerFormInfo!.taxIdErrors).reduce((acc, key) => {
          acc[key] = 'TAX ID is invalid';
          return acc;
        }, { ...customerFormInfo!.taxIdErrors })
      ));
      return;
    }

    if (triggerResult) { // if the form data is valid
      dispatch(setCustomerFormInfoTaxIdErrors(
        Object.keys(customerFormInfo!.taxIdErrors).reduce((acc, key) => {
          acc[key] = '';
          return acc;
        }, { ...customerFormInfo!.taxIdErrors })
      ));
      navigate("/payment/card")
    }
  }

  return (
    <div className={styles.customerInfo}>
      <PageTitle title={`Customer information`} />
      <CustomerBillingInfoForm ref={customerInfoFormRef} />

      <div className={styles.flexRightContainer}>
        <Button
          variant="default"
          onClick={handleRedirect}
          style={{ maxWidth: 120, marginTop: 16 }}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default CustomerInfo;
